<template>
  <div class="col-lg-6">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Promjena lozinke</h4>
      </div>
      <div class="card-body custom-alert">
        <b-alert
          v-model="wrongPasswordAlert"
          v-height-fade.appear
          variant="danger"
          dismissible
          class="mb-0"
        >
          <div class="alert-body">
            Trenutna loznika koju ste unijeli nije ispravna! Pokušajte ponovo.
          </div>
        </b-alert>
      </div>
      <div class="card-body">
        <validation-observer ref="passwordForm">
          <b-form @submit.prevent="submitForm">
            <b-row>
              <!-- TRENUTNA LOZINKA -->
              <b-col cols="12">
                <b-form-group
                  label="Trenutna lozinka"
                  label-for="current-password"
                  label-cols-md="4"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Password"
                    vid="Password"
                    rules="required|min:6"
                  >
                    <b-input-group class="input-group-merge">
                      <b-input-group-prepend is-text>
                        <feather-icon icon="LockIcon" />
                      </b-input-group-prepend>

                      <b-form-input
                        v-model="model.currentPassword"
                        id="current-password"
                        type="password"
                        placeholder="Trenutna lozinka"
                      />
                    </b-input-group>
                    <div class="text-danger">{{ errors[0] }}</div>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- NOVA LOZINKA -->
              <b-col cols="12">
                <b-form-group
                  label="Nova lozinka"
                  label-for="new-password"
                  label-cols-md="4"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="NewPassword"
                    vid="NewPassword"
                    rules="required|min:6"
                  >
                    <b-input-group class="input-group-merge">
                      <b-input-group-prepend is-text>
                        <feather-icon icon="LockIcon" />
                      </b-input-group-prepend>
                      <b-form-input
                        v-model="model.newPassword"
                        id="new-password"
                        type="password"
                        placeholder="Nova lozinka"
                      />
                    </b-input-group>
                    <div class="text-danger">{{ errors[0] }}</div>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- POTVRDA NOVE LOZINE -->
              <b-col cols="12">
                <b-form-group
                  label="Potvrda nove lozinke"
                  label-for="confirm-new-password"
                  label-cols-md="4"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="ConfirmNewPassword"
                    vid="ConfirmNewPassword"
                    rules="required|confirmed:NewPassword"
                  >
                    <b-input-group class="input-group-merge">
                      <b-input-group-prepend is-text>
                        <feather-icon icon="LockIcon" />
                      </b-input-group-prepend>
                      <b-form-input
                        v-model="confirmPassword"
                        id="confirm-new-password"
                        type="password"
                        placeholder="Nova lozinka"
                      />
                    </b-input-group>
                    <div class="text-danger">{{ errors[0] }}</div>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- submit and reset -->
              <b-col offset-md="4">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  class="mr-1"
                >
                  Sačuvaj
                </b-button>
                <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  type="reset"
                  variant="outline-secondary"
                  ref="resetButton"
                >
                  Poništi
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BInputGroup,
  BInputGroupPrepend,
  BRow,
  BCol,
  BAlert,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import { heightFade } from "@core/directives/animations";
import { required, min, confirmed } from "@validations";
import store from "@/store/index";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BAlert,
  },
  directives: {
    "height-fade": heightFade,
    Ripple,
  },
  data() {
    return {
      wrongPasswordAlert: false,
      confirmPassword: null,
      model: { currentPassword: null, newPassword: null },
    };
  },
  mounted() {
    localize("en", {
      code: "en",
      fields: {
        Password: {
          required: "Polje je obavezno",
          min: "Minimalna dužina lozinke je 6 karaktera",
        },
        NewPassword: {
          required: "Polje je obavezno",
          min: "Minimalna dužina lozinke je 6 karaktera",
        },
        ConfirmNewPassword: {
          required: "Polje je obavezno",
          confirmed: "Lozinke se ne poklapaju",
        },
      },
    });
  },
  methods: {
    submitForm() {
      var $this = this;
      $this.wrongPasswordAlert = false;
      this.$refs.passwordForm.validate().then((success) => {
        if (success) {
          store
            .dispatch("account/CHANGE_PASSWORD", this.model)
            .then((response) => {
              $this.$swal({
                position: "bottom-end",
                icon: "success",
                title: "Uspješno ste promijenili lozniku",
                showConfirmButton: false,
                timer: 1500,
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                buttonsStyling: false,
              });
              $this.$refs.resetButton.click();
            })
            .catch((error) => {
              if (error.data.message == "Wrong current password")
                $this.wrongPasswordAlert = true;
            });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-alert {
  padding-bottom: 0;
}
</style>
